export const getCDNUrl = () => {
  return import.meta.env.VITE_CDN_URL
}

export const getJamsBackendApi = () => {
  return import.meta.env.VITE_JAMS_BACKEND_URL
}

export const getJamsFrontendApi = () => {
  return import.meta.env.VITE_JAMS_FRONTEND_URL
}

// Get account id from url or DOM
export function getAccountIdFromUrlOrDom(): string {
  // Check URL parameters first
  const urlParams = new URLSearchParams(window.location.search)
  const accountIdFromUrl = urlParams.get('account_id')

  console.log('accountIdFromUrl: ', accountIdFromUrl)

  if (accountIdFromUrl && accountIdFromUrl !== '') return accountIdFromUrl

  // Check DOM attributes
  const wpElement = document.getElementById('lightning-model-page-admin')
  const accountIdFromElement = wpElement?.getAttribute('data-account-id')

  console.log('accountIdFromElement: ', accountIdFromElement)

  if (accountIdFromElement && accountIdFromElement !== '') return accountIdFromElement

  return ''
}

// Format account name
export const formatAccountName = (name: string): string => {
  return name.replace(/_/g, ' ')
}

// Check if the url is valid or not
export const isValidUrl = (url: string): boolean => {
  const urlPattern = new RegExp(
    /^(https?:\/\/)?(www\.)?([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,})(\/[^\s]*)?$/i,
  )
  return urlPattern.test(url)
}

/**
 * Date relation utils
 */
// Get first day of last month
export const getFirstDayOfLastMonthAsDate = (): Date => {
  const date = new Date()
  date.setMonth(date.getMonth() - 1, 1) // First day of last month
  return date
}

// Get last day of last month
export const getLastDayOfLastMonthAsDate = (): Date => {
  const date = new Date()
  date.setMonth(date.getMonth(), 0) // Last day of last month
  return date
}

// Get first day of current month
export const getFirstDayOfCurrentMonthAsDate = (): Date => {
  const date = new Date()
  date.setDate(1) // First day of current month
  return date
}

// Get last day of current month
export const getLastDayOfCurrentMonthAsDate = (): Date => {
  const date = new Date()
  date.setMonth(date.getMonth() + 1, 0) // Last day of current month
  return date
}

// Calculate change as percentage
export const calculatePercentageChange = (current: number, previous: number) => {
  if (previous === 0) return 0
  return ((current - previous) / previous) * 100
}

// Format date
export const formatDate = (date: Date): string => {
  return date.toISOString().split('T')[0] // Returns YYYY-MM-DD
}

// Compare dates
export const compareDates = (date1: Date | undefined, date2: Date | undefined) => {
  if (!date1 || !date2) return false

  return (
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()
  )
}

// Get first and last day of current month
export const getCurrentMonthBounds = () => {
  const now = new Date()

  // First day of current month
  const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)
  firstDay.setHours(0, 0, 0, 0)

  // Last day of current month
  const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0)
  lastDay.setHours(23, 59, 59, 999)

  return {
    start: firstDay,
    end: lastDay,
  }
}

// Get first and last day of last month
export const getLastMonthBounds = () => {
  const now = new Date()

  // First day of last month
  const firstDay = new Date(now.getFullYear(), now.getMonth() - 1, 1)
  firstDay.setHours(0, 0, 0, 0)

  // Last day of last month
  const lastDay = new Date(now.getFullYear(), now.getMonth(), 0)
  lastDay.setHours(23, 59, 59, 999)

  return {
    start: firstDay,
    end: lastDay,
  }
}

export const getDefaultGoogleFonts = (): string[] => {
  return ['Roboto']
}
